module.exports = __webpack_public_path__ + "static/media/16x24no3.dda6c027.jpg";